import { useState } from 'react';
import { api } from '../../api';
import { ApiError, type HuntOrder } from '../../api/types';
import { t } from '../../i18n/idioma';
import { PilulaIdle } from './PilulaIdle';
import { useTempoCacada } from './useTempoCacada';

/**
 * A caçada minimizada (techspec-hud-v3 §18), no mesmo padrão da coleta: entra assim quando a caçada começa.
 * Pause = pausa o combate automático (modo manual, POST /hunts/manual); play = o combate automático volta (POST /hunts/auto). Sair = Voltar
 * para a cidade (POST /hunts/cancel). Clicar no texto abre a janela "Em caçada".
 */
export function PilulaCacada({
  ordem, manual, onAbrir, onOrdem, onModo, onAviso
}: {
  ordem: HuntOrder;
  /** O modo que a sala conhece (o teclado também troca); sem sala, o da ordem. */
  manual: boolean;
  onAbrir(): void;
  onOrdem(ordem: HuntOrder | null): void;
  /** A etiqueta AUTO/MANUAL da barra; no mock não há aviso da sala para trocá-la. */
  onModo(manual: boolean): void;
  onAviso(texto: string): void;
}) {
  const [busy, setBusy] = useState(false);
  const tempo = useTempoCacada(ordem.startedAt) ?? '--:--';
  // Área protegida (techspec-cacada-protegida): a pílula diz "· Protegida".
  const lugar = ordem.area === 'protegida'
    ? t('idle.cacada.lugarProtegido', { lugar: t(`cacada.${ordem.huntId}.nome`) })
    : t(`cacada.${ordem.huntId}.nome`);

  async function chamar(fn: () => ReturnType<typeof api.autoHunt>) {
    if (busy) return;
    setBusy(true);
    try {
      const board = await fn();
      onOrdem(board.ordem);
      onModo(board.ordem?.modo === 'manual');
    } catch (e) {
      onAviso(e instanceof ApiError ? e.message : t('comum.recusouPedido'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <PilulaIdle
      className="cl-min ch-min"
      estado={manual ? t('idle.cacada.pausada', { lugar }) : t('idle.cacada.ativa', { lugar })}
      relogio={tempo}
      pausado={manual}
      podePausar
      ocupado={busy}
      abrirDica={t('idle.cacada.abrir')}
      sairDica={t('idle.sairCacada')}
      onAbrir={onAbrir}
      onPausa={() => void chamar(manual ? () => api.autoHunt() : () => api.manualHunt())}
      onSair={() => void chamar(() => api.cancelHunt())}
    />
  );
}
